<template>
  <myDialog :isDialog="isImportDialog" :title="'数据导入'" :width="'50%'" @handleClose="handleClose">
    <template slot="content">
      <div class="dialogContent">
        <div class="step" style="margin-bottom: 24px;">
          <div class="stepTitle">第一步：</div>
          <div class="stepContent">
            <a href="#">下载excel模版</a>
          </div>
        </div>
        <div class="step">
          <div class="stepTitle">第二步：</div>
          <div class="stepContent">
            <el-upload action :show-file-list="false" :on-change="uploadChange">
              <div class="selectFile">
                <img src="@/assets/images/importDataDialog/icon-down.png" alt="">
                <span>选择文件</span>
              </div>
            </el-upload>
            <div class="warning" v-if="isFile && type=='base'">
              <i class="el-icon-loading" style="color: #0C7BF2;"></i>
              <span style="color: #0C7BF2;">正在导入</span>
            </div>
            <div class="warning" v-if="!isFile && type=='base'">
              <img src="@/assets/images/importDataDialog/icon-warning.png" alt="">
              <span>未选择文件</span>
            </div>
            <img src="@/assets/images/importDataDialog/icon-list-success.png" v-if="percentage==100 && type == 'success'" alt="">
            <div class="warning" v-if="type == 'error'">
              <img src="@/assets/images/importDataDialog/icon-warning.png" alt="">
              <span>附件格式错误</span>
            </div>
          </div>
        </div>
        <div class="importInfo" v-if="isFile || type=='success'">
          <el-progress :percentage="percentage" :status="type == 'base' ? '' : type == 'success' ? 'success' : 'exception'"
            text-inside :stroke-width="16"></el-progress>
          <!-- <el-progress :percentage="50" :define-back-color="type=='base'?'#0C7BF2':type=='success'?'#63D9B5':'#FD7A79'" text-inside  :stroke-width="16"></el-progress> -->
          <div class="importState">
            <template>
              <span>{{ type == 'base' ? '正在导入...' : type == 'success' ? '导入成功' : '导入失败' }}</span>
              <div class="num">{{ percentage }}%</div>
            </template>
          </div>
          <!-- 导入成功 -->
          <div class="describeSuccess" v-if="type == 'success'">
            <img src="@/assets/images/importDataDialog/icon-success.png" alt="">
            <span>您已成功导入8条数据</span>
          </div>
          <!-- 导入失败 -->
          <div class="describeError" v-if="type == 'error'">
            <img src="@/assets/images/importDataDialog/icon-danger.png" alt="">
            <div class="text">本次共导入<span>786</span>条数据，
              成功导入<span>784</span>条，空教据有<span>0</span>条，导入失败<span>2</span>条。
              (请先下载<a href="#">错误分析表</a>，表中红色标注的数据为错误数据，修改后可再次导入）
            </div>
          </div>
        </div>
        <div class="importList" v-if="isFile || type=='success'">
          <div class="header">
            <img src="@/assets/images/importDataDialog/icon-jd.png" alt="">
            <span>详细进度</span>
          </div>
          <!-- <div class="list"> -->
          <transition-group tag="div" class="list" name="why" mode="in-out">
            <div class="listItem item" v-for="(item, index) in filtList" :key="item">
              <div class="left">Step {{ index + 1 }}</div>
              <div class="centre" :style="{ 'color': type == 'base' ? '#6B7885' : type == 'success' ? '#63D9B5' : '#fd7a79' }">
                {{ item.name }}</div>
              <div class="right">
                <span v-if="type == 'base'">进行中...</span>
                <img v-if="type == 'success'" src="@/assets/images/importDataDialog/icon-list-success.png" alt="">
                <img v-if="type == 'error'" src="@/assets/images/importDataDialog/icon-list-error.png" alt="">
              </div>
            </div>
          </transition-group>
          <!-- </div> -->
        </div>
      </div>
    </template>
  </myDialog>
</template>

<script>
export default {
  props: {
    isImportDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filtList:[
        {
          name:'数据有效性验证',
        },
        {
          name:'正在保存数据库',
        },
        {
          name:'正在保存数据库',
        },
        {
          name:'正在保存数据库',
        },
        {
          name:'正在保存数据库',
        },
        {
          name:'正在保存数据库',
        },
        {
          name:'正在保存数据库',
        },
      ],
      isFile: false,//是否有文件
      percentage: 0,
      type: 'base',//文件导入状态 base,error,success
    }
  },
  mounted() {

  },
  computed:{
  
  },
  methods: {
    uploadChange(file) {
      console.log(12);
      this.isFile = file.name;
      let time = null;
      if (this.isFile) {//有文件
        time = setInterval(() => {
          if (this.percentage >= 100) {
            this.isFile = false;
            this.type = 'success';
            clearInterval(time)
          } else {
            this.percentage++;
          }
        }, 50);

      }
      // setInterval(() => {
      //   this.del()
      // }, 1000);
    },
    del(){
      this.filtList.shift();
      this.filtList[0].name= '数据有效性验证';
    },
    handleClose() {
      this.$emit('handleClose')
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  
}

.why-enter-from,
.why-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
.why-enter-active,
.why-leave-active{
  transition: all 1s ease;
}
.why-leave-active{
  /* 删除的数字,虽然消失了,但是执行动画的过程中,它的位置还是被占据的,所以当移除数字时,把当前数字用绝对定位脱离标准流,就可以了 */
  position: absolute;
}
.why-move{
  transition: transform 1s ease;
}
.dialogContent {
  width: 100%;
  padding: 20px 0;

  .step {
    height: 74px;
    border-radius: 5px;
    background: #fcfcfc;
    display: flex;

    .stepTitle {
      width: 140px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #0c7bf24d;
      border-right: none;
      border-radius: 5px 0px 0px 5px;

      color: #2a3347;
      font-weight: bold;
      font-size: 20px;
      letter-spacing: 2px;
    }

    .stepContent {
      flex: 1;
      border: 1px dashed #0c7bf24d;
      border-radius: 0px 5px 5px 0px;
      padding: 0 24px 0 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      a {
        color: #0C7BF2;
      }

      img {
        width: 24px;
        height: 24px;
      }

      .selectFile {
        display: flex;
        align-items: center;
        border-radius: 5px;
        border: 1px solid #d1d5dc;
        padding: 8px 20px;

        span {
          margin-left: 7px;
          color: #616a79;
          font-weight: 500;
          font-size: 14px;
        }
      }

      .warning {
        display: flex;
        align-items: center;

        span {
          margin-left: 8px;
          color: #edc663;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
  }

  .importInfo {
    border-radius: 5px;
    background: #F7FBFE;
    padding: 23px 24px 18px 32px;

    .importState {
      margin-top: 11px;
      display: flex;
      justify-content: space-between;
    }

    .describeSuccess {
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }

      span {
        color: #63d9b5;
        font-weight: bold;
        font-size: 14px;
      }
    }

    .describeError {
      margin-top: 10px;
      display: flex;

      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }

      .text {
        color: #000000;
        font-weight: 500;
        font-size: 14px;

        span {
          color: #0c7bf2;
        }

        a {
          color: #FD7A79;
          text-decoration: none;
        }
      }
    }
  }

  .importList {
    .header {
      display: flex;
      align-items: center;
      border-radius: 5px;
      border: 1px dashed #0c7bf24d;
      padding: 13px 32px;
      margin-top: 24px;

      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }

      span {
        color: #2a3347;
        font-weight: bold;
        font-size: 16px;
      }
    }

    .list {
      display: flex;
      flex-direction: column;

      .listItem {
        height: 40px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        margin-top: 8px;
        color: #6b7885;
        font-weight: 500;
        font-size: 14px;

        >div {
          height: 100%;
        }

        .left {
          width: 120px;
          border-left: 1px dashed #9CB7D0;
          border-right: 1px dashed #9CB7D0;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .centre {
          padding: 0 32px;
          flex: 1;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        .right {
          width: 200px;
          border-left: 1px dashed #9CB7D0;
          border-right: 1px dashed #9CB7D0;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
}

</style>
